angular.module('tf.services')

    .service('StorageService', [function(){

        localforage.config({
            //driver      : localforage.WEBSQL, // Force WebSQL; same as using setDriver()
            name        : 'tfStorage',
            //version     : 1.0,
            size        : 31457280, // Size of database, in bytes. WebSQL-only for now.
            storeName   : 'data' // Should be alphanumeric, with underscores.
            //description : 'some description'
        });

        this.store = function(key, value){
            return localforage.setItem(key, value);
        };
        this.load = function(key){
            return localforage.getItem(key);
        };
        this.delete = function(key){
            return localforage.removeItem(key);
        };

        return this;

    }]);
